import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const inputVariants = cva('flex w-full items-center gap-1 overflow-hidden rounded-ads-md border border-solid bg-background px-3 transition-colors', {
  variants: {
    size: {
      Small: 'py-1 h-[2rem]',
      Default: 'py-2 h-[2.5rem]',
      Large: 'py-2.5 h-[2.75rem]'
    },
    error: {
      true: 'border-destructive text-destructive shadow-[0px_0px_0px_3px_rgba(220,38,38,0.2)]',
      false: ''
    }
  },
  defaultVariants: {
    size: 'Default',
    error: false
  }
});
const Input = /*#__PURE__*/React.forwardRef(({
  className,
  type,
  size = 'Default',
  error = false,
  iconLeft,
  iconRight,
  ...props
}, ref) => {
  return /*#__PURE__*/_jsxs("div", {
    className: cn(inputVariants({
      size,
      error
    }), !error && 'border-input focus-within:border-ring focus-within:shadow-[0px_0px_0px_3px_rgba(161,161,170,0.5)]', props.disabled && 'pointer-events-none opacity-50', className),
    children: [iconLeft && /*#__PURE__*/_jsx("div", {
      className: "flex items-center justify-center w-4 h-6 shrink-0",
      children: iconLeft
    }), /*#__PURE__*/_jsx("input", {
      type: type,
      ref: ref,
      className: cn('flex-1 min-w-0 bg-transparent text-foreground text-body-md outline-none', 'placeholder:text-muted-foreground', 'disabled:cursor-not-allowed', error && 'text-destructive placeholder:text-destructive/60'),
      ...props
    }), iconRight && /*#__PURE__*/_jsx("div", {
      className: "flex items-center justify-center w-4 h-6 shrink-0",
      children: iconRight
    })]
  });
});
Input.displayName = 'Input';
export { Input, inputVariants };